export const treeToList = (tree, result = [], level = 0) => {
    tree.forEach((node) => {
        result.push(node)
        node.level = level + 1
        node.childEntity && treeToList(node.childEntity, result, level + 1)
    })
    return result
}
